import {getCommonVisualizerType} from "../../config";
import store from "../../store";


/**
 * Checks whether to show room feature as in visualizer in the navigation
 * @param feature {featureInterface}
 * @returns {featureInterface}
 */
export const setRoomNotInVisualizerProperty = (feature) => {
  const fabricatorSubscriptions = store.getState().fabricatorState.fabricatorSubscriptions;
  if (!feature || !feature.dbFeature || !feature.dbFeature.sharedFeatureName) {
    return feature
  }
  const name = feature.dbFeature.sharedFeatureName.toLowerCase();
  const visType = getCommonVisualizerType();
  if (name === visType) {
    feature.notAvailableInVisualizer = false;
    feature.dbFeature.unlocked = true;
    return feature
  }
  if (!Array.isArray(fabricatorSubscriptions)) {
    return feature
  }
  const subscription = fabricatorSubscriptions.find(subscr => subscr.service.toLowerCase() === name);
  if (subscription) {
    feature.notAvailableInVisualizer = false;
    feature.dbFeature.unlocked = true;
    if (subscription.thumbnail) {
      feature.customThumbnail = subscription.thumbnail
    }
  }
  return feature
}
